import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import EditIcon from "@mui/icons-material/Edit";
import * as Yup from "yup";
import Tooltip from "@mui/material/Tooltip";
import useAxios from "../../../../api/useAxios";
import { useLocation } from "react-router";
import { useFormik } from "formik";
import SchoolIcon from '@mui/icons-material/School';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Chip from '@mui/material/Chip';
import Context from "../Context";
import { university } from "./Univercity";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function College({ setput }) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const [open, setOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [CollegeName, setCollegeName] = useState();
  const handleClickOpen = (College) => {
    setOpen(true);
    // formik.setFieldValue("College", College.College);
    formik.setFieldValue("collegeName", College.collegeName);
    formik.setFieldValue("collegeLocation", College.collegeLocation);
    formik.setFieldValue("collegeCity", College.collegeCity);
     formik.setFieldValue("currentCourse", College.currentCourse);
    formik.setFieldValue("collegePincode", College.collegePincode);
  };

  const handleClose = () => {
    formik.handleReset("");
    setOpen(false);
  };
  const axiosData = useAxios();

  const location = useLocation();

  const formik = useFormik({
    initialValues: {
      collegeName: "",
      collegeLocation: "",
      collegeCity: "",
      collegePincode: "",
      currentCourse:""
    },

    validationSchema: Yup.object({
      collegeLocation: Yup.string().required("College location must be required"),
      collegeName: Yup.string().required("College name must be required"),
       collegeCity: Yup.string().required("College city must be required"),
       currentCourse: Yup.string().required("Current course must be required"),
      collegePincode: Yup.string().required("College pincode must be required"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true);
      await axiosData.put(`seeker/email/${location.state}`, {
        College: {
          collegeName: values.collegeName,
          collegeLocation: values.collegeLocation,
          collegeCity: values.collegeCity,
          currentCourse:values.currentCourse,
          collegePincode: values.collegePincode,
        },
      });
      setput(true);
      setIsSubmitting(false);
      formik.handleReset("");
      handleClose();
    },
  });

  useEffect(() => {
    setCollegeName(formik.values.College);
  }, [formik.values.College]);
  return (
    <Context.Consumer>
      {(context) => {
        let College = "";
        if (context.profile.College) {
          College = context.profile.College;
        }

        return (
          <div>
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              aria-describedby="alert-dialog-slide-description"
              sx={{ "& .MuiPaper-root": { width: "500px" } }}
            >
              <form onSubmit={formik.handleSubmit}>
                <DialogTitle>
                  <Typography variant="h5">
                    <b>College</b>
                  </Typography>
                  <Grid item xs={12} sm={12} md={8} square>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        mt: 1,
                      }}
                      color="text.secondary"
                    >
                      Mention your College details.
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ p: 3 }}>
                         <FormControl className="Educationfieldsize">
                          <TextField
                            //disabled={!educationName}
                            placeholder={"Enter Current course name"}
                            name="currentCourse"
                            label={"Course name"}
                            value={formik.values.currentCourse}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="currentCourse"
                          />
                          {formik.touched.currentCourse &&
                            formik.errors.currentCourse && (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.currentCourse}
                              </Typography>
                            )}
                        </FormControl>

                        <FormControl sx={{ mt: 2 }} className="Educationfieldsize">
                          <TextField
                            //disabled={!educationName}
                            placeholder={"Enter College name"}
                            name="collegeName"
                            label={"College name"}
                            value={formik.values.collegeName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="collegeName"
                          />
                          {formik.touched.collegeName &&
                            formik.errors.collegeName && (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.collegeName}
                              </Typography>
                            )}
                        </FormControl>

                        <FormControl  sx={{ mt: 2 }}className="Educationfieldsize">
                          <TextField
                            //disabled={!educationName}
                            placeholder={"Enter College location"}
                            name="collegeLocation"
                            label={"College Location"}
                            value={formik.values.collegeLocation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="collegeLocation"
                          />
                          {formik.touched.collegeLocation &&
                            formik.errors.collegeLocation && (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.collegeLocation}
                              </Typography>
                            )}
                        </FormControl>
                        <FormControl  sx={{ mt: 2 }}className="Educationfieldsize">
                          <TextField
                            //disabled={!educationName}
                            placeholder={"Enter College City"}
                            name="collegeCity"
                            label={"College City"}
                            value={formik.values.collegeCity}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="collegeCity"
                          />
                          {formik.touched.collegeCity &&
                            formik.errors.collegeCity && (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.collegeCity}
                              </Typography>
                            )}
                        </FormControl>
                        <FormControl  sx={{ mt: 2 ,mb:2}}className="Educationfieldsize">
                          <TextField
                            //disabled={!educationName}
                            placeholder={"Enter College pincode"}
                            name="collegePincode"
                            label={"College Pincode"}
                            value={formik.values.collegePincode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="collegePincode"
                          />
                          {formik.touched.collegePincode &&
                            formik.errors.collegePincode && (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.collegePincode}
                              </Typography>
                            )}
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </DialogTitle>

                <DialogActions sx={{ mr: 2, mt: -6, mb: 1 }}>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={
                      formik.isValid && formik.dirty && isSubmitting === false
                        ? false
                        : true
                    }
                    variant="contained"
                    type="submit"
                  >
                    Update
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        style={{
                          color: "#ffffff",

                          marginLeft: 12,
                        }}
                      />
                    )}
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
            <Grid xs={12} md={12} lg={12}>
              <Box
                id="College"
                sx={{ fontSize: "18px", textTransform: "uppercase" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <b style={{ color: "rgb(16 143 178)" }}>College</b>
                  <Button
                    sx={{ ml: -1.5, mt: -1 }}
                    onClick={() => handleClickOpen(College)}
                  >
                    <Tooltip title="Edit" arrow>
                      <EditIcon />
                    </Tooltip>
                  </Button>
                </Box>
              </Box>
              <hr />
              {College.collegeName ? (
                // <>
                //   {" "}
                //   <Typography
                //     sx={{ fontWeight: 600 }}
                //     variant="h5"
                //     component="div"
                //     color="text.secondary"
                //   >
                //     {College.collegeName}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {College.collegeLocation}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {College.collegeCity}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {College.collegePincode}
                //   </Typography>
                // </>
              <Box sx={{ 
  backgroundColor: 'rgba(166, 199, 212, 0.1)',
  borderRadius: 3,
   p: { xs: 2, sm: 3 },
  border: '1px solid #e2e8f0',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #f1b8ceff 0%, #e65992ff 100%)'
  }
}}>
 <Box sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    mb: 3,
    flexDirection: { xs: 'row', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'flex-start' }
  }}>
    <Box sx={{ 
      backgroundColor: '#f0f7ff',
      p: 1.5,
      display:{xs:"none",sm:"block"},
      borderRadius: 2,
      mr: { xs: 1, sm: 2 },
      mb: { xs: 0, sm: 0 }
    }}>
      <SchoolIcon sx={{ fontSize:{ xs: 20, sm: 28 }, color: "#135c82" }} />
    </Box>
    <Typography
      variant="h5"
      sx={{ 
        fontWeight: 700,
        color: 'text.secondary',
        flex: 1,
        fontSize: { xs: '1.05rem', sm: '1.5rem' },
        textAlign: { xs: 'left', sm: 'left' }
      }}
    >
      {College.collegeName || 'College Name'}
    </Typography>
  </Box>
  
  <Box sx={{ 
    display: 'flex',
    flexWrap: 'wrap',
    gap: { xs: 1, sm: 2 },
    '& .MuiChip-icon': {
      color: '#135c82 !important'
    },
    mb: 2
  }}>
    <Chip
      icon={<LocationOnIcon />}
      label={College.collegeLocation || 'Location not specified'}
      variant="outlined"
      sx={{ 
        color: 'text.secondary',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        backgroundColor: '#f8fafc',
        fontSize: { xs: '0.75rem', sm: '0.875rem' },
        height: { xs: 32, sm: 36 }
      }}
       size="small"
    />
    <Chip
      icon={<LocationCityIcon />}
      label={College.collegeCity || 'City not specified'}
      variant="outlined"
      sx={{ 
        color: 'text.secondary',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        backgroundColor: '#f8fafc',
      fontSize: { xs: '0.75rem', sm: '0.875rem' },
        height: { xs: 32, sm: 36 }
      }}
      size="small"
    />
    <Chip
      icon={<PinDropIcon />}
      label={`${College.collegePincode || '—'}`}
      variant="outlined"
      sx={{ 
        color: 'text.secondary',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        backgroundColor: '#f8fafc',
       fontSize: { xs: '0.75rem', sm: '0.875rem' },
        height: { xs: 32, sm: 36 }
      }}
      size="small"
    />
  </Box>
  {/* If course field is named differently */}
{College.currentCourse && (
  <Box sx={{ 
    pt: 1,
    borderTop: '1px solid #e2e8f0'
  }}>
    <Typography
      variant="subtitle1"
      sx={{ 
        fontWeight: 600,
        color: 'text.secondary',
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontSize: { xs: '0.875rem', sm: '1rem' }
      }}
    >
     <MenuBookIcon sx={{ color: "#135c82", fontSize: { xs: 18, sm: 20 } }} />
      Current Study
    </Typography>
    
    <Chip
      icon={<SchoolIcon />}
      label={College.currentCourse}
      variant="outlined"
      sx={{ 
        borderRadius: 2,
        borderColor: '#e2e8f0',
        color: 'text.secondary',
        backgroundColor: '#f8fafc',
        '& .MuiChip-icon': {
          color: '#135c82 !important'
        }
    ,
     '& .MuiChip-label': {
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'left',
          display: 'block',
          padding: '4px 8px',
          maxWidth: '100%'
        },
          height: 'auto',
        maxWidth: '100%',
        display: 'inline-flex',
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
        }}
        size="small"
    />
  </Box>
)}
</Box>
              ) : (
                <Typography
                  sx={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontSize: "14px",
                    mt: 1,
                  }}
                  color="text.secondary"
                >
                  Mention your College details.
                </Typography>
              )}
            </Grid>
          </div>
        );
      }}
    </Context.Consumer>
  );
}

export default College;
